/**
 * Extracts color values from a CSS gradient string
 * Supports hex, rgb, rgba, hsl, and hsla color formats
 */
export const extractColorsFromGradient = (gradient: string): string[] => {
    const colorMatches = gradient.match(
        /#[0-9a-fA-F]{3,6}|rgb\([^)]+\)|rgba\([^)]+\)|hsl\([^)]+\)|hsla\([^)]+\)/g
    );
    return colorMatches || [];
};

/**
 * Gets the primary icon color from an assistant's gradient or accent color
 */
export const getIconColorFromAssistant = (
    bgGradient?: string,
    accentColor?: string,
    defaultColor: string = '#22d3ee'
): string => {
    if (!bgGradient) return accentColor || defaultColor;

    const gradientColors = extractColorsFromGradient(bgGradient);
    return gradientColors[0] || accentColor || defaultColor;
};

/**
 * Gets both primary and secondary colors from a gradient
 */
export const getGradientColors = (
    bgGradient?: string,
    accentColor?: string
): { primary: string; secondary: string } => {
    const gradientColors = extractColorsFromGradient(bgGradient || '');
    const primary = gradientColors[0] || accentColor || '#6366f1';
    const secondary = gradientColors[1] || primary;

    return { primary, secondary };
};